export default __webpack_public_path__ + "static/media/splashScreen.aea5fcd6.png";